import React from "react";
import { Link } from "react-router-dom";
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/_uiMocks/components/grid-container/GridContainer";
import Logo from "../../styles/img/sb-logo.png"
const UiDemo = (props) => {
    return (
        <div>
            <UiRowContainer>
                <UiCol lg="6" className="mt-5 sb-ui-links-st">
                    <img src={Logo} width="150" className="mb-3"/>
                    <a href={"/ui/signup"}><h3>Signup</h3></a>
                    <a href={"/ui/signup-step-two"}><h3>Signup-step-two</h3></a>

                    
                    <a href={"/ui/login"}><h3>Login</h3></a>
                    <Link to="/ui/landing-page"><h3>Landing Page</h3></Link>
                    <a href={"/ui/home"}><h3>Home</h3></a>
                    <h2>Campaigns</h2>
                    <a href={"/ui/campaigns"}><h3>Incentives</h3></a>
                    <a href={"/ui/incentives-pre-register"}><h3>Incentives Pre Register</h3></a>
                    <Link to="/ui/incentives-league-individual"><h3>Incentives League Individual</h3></Link>
                    <Link to="/ui/incentives-league-team"><h3>Incentives League Team</h3></Link>
                    <Link to="/ui/incentives-direct-win"><h3>Incentives Direct Win</h3></Link>
                    <Link to="/ui/incentives-spin-win-home"><h3>Incentives Spin Win</h3></Link>
                    <Link to="/ui/incentives-banded"><h3>Incentives Banded</h3></Link>
                    <Link to="/ui/incentives-prize-draw"><h3>Incentives Prize Draw</h3></Link>
                    <Link to="/ui/incentives-prize-draw-winner"><h3>Incentives Prize Draw Winner</h3></Link>

                  
                   
                    <h2>Knowledge</h2>
                    <Link to="/ui/learn"><h3>Knowledge Dashboard</h3></Link>
                    <Link to="/ui/all-quizzers"><h3>All Quizzers</h3></Link>
                    <Link to="/ui/completed-quizzers"><h3>Completed Quizzers</h3></Link>
                    <Link to="/ui/quiz-home"><h3>Quiz Home</h3></Link>
                    <Link to="/ui/correct-image-q-template"><h3>Select Correct Image Template</h3></Link>
                    <Link to="/ui/correct-image-q-template-multiple"><h3>Select Correct Image Multiple Template</h3></Link>
                    <Link to="/ui/template-mcq-image"><h3>Template - MCQ - Image</h3></Link>
                    <Link to="/ui/template-mcq-video"><h3>Template - MCQ - Video</h3></Link>
                    <Link to="/ui/template-mcq-multiple"><h3>Template - MCQ Multiple answers</h3></Link>                    
                    <Link to="/ui/template-range"><h3>Template - Range</h3></Link>
                    <Link to="/ui/template-open-question"><h3>Template - Open Question</h3></Link>
                    <Link to="/ui/template-feedback"><h3>Template - Feedback</h3></Link>
                    <Link to="/ui/template-section-divider"><h3>Template - Section Divider</h3></Link>
                    <Link to="/ui/template-section-divider-with-image"><h3>Template - Section Divider With Image</h3></Link>
                    <Link to="/ui/template-assesment-failed"><h3>Template - Assesment Failed</h3></Link>
                    <Link to="/ui/template-assesment-passed"><h3>Template - Assesment Passed</h3></Link>
                    
                    
                    <h2>Shop</h2>
                    <Link to="/ui/shop"><h3>Shop</h3></Link>
                    <Link to="/ui/browse-product"><h3>Browse Product</h3></Link>
                    <Link to="/ui/membership"><h3>Membership</h3></Link>
                    <Link to="/ui/product-information"><h3> Product Information</h3></Link>
                    <Link to="/ui/order-confirmation"><h3>Order Confirmation</h3></Link>
                    <Link to="/ui/order-checkout"><h3>Order Checkout</h3></Link>
                    <Link to="/ui/order-details"><h3>Order Details</h3></Link>
                    <Link to="/ui/voucher-wallet"><h3>Voucher Wallet</h3></Link>
                    <h2>Loyalty</h2>
                    <Link to="/ui/loyalty"><h3>Loyalty Home</h3></Link>
                    <Link to="/ui/loyalty-home-signed-up"><h3>Loyalty Home Signed Up</h3></Link>
                    <Link to="/ui/loyalty-store"><h3>Loyalty Store</h3></Link>
                    <h2>Points Banking</h2>
                    <Link to="/ui/points-banking#account-history"><h3>Points Banking</h3></Link>
                    <h2>Badges</h2>
                    
                    <Link to="/ui/badges-dashboard"><h3>Badges Dashboard</h3></Link>
                    <Link to="/ui/view-badges"><h3>View Badges</h3></Link>
                    <Link to="/ui/view-badges-details"><h3>View Badges Details</h3></Link>
                  
                    <Link to="/ui/view-quizzers-badges"><h3>Badges - View Quizzers</h3></Link>
                    <Link to="/ui/view-quizzers-badges-in-progress"><h3>Badges - View Quizzers - in progress</h3></Link>
                    <Link to="/ui/view-quizzers-badges-completed"><h3>Badges - View Quizzers - Completed</h3></Link>
                    <Link to="/ui/home-badges"><h3>Badges - Home</h3></Link>
                    <Link to="/ui/course-end"><h3>Course - End</h3></Link>
                    <Link to="/ui/course-in-progress"><h3>Course - In progress</h3></Link>
                    <Link to="/ui/course-completed"><h3>Course - Completed</h3></Link>
                    <Link to="/ui/course-quiz-home"><h3>Course - Quiz - Home</h3></Link>
                    <Link to="/ui/course-assesment-passed"><h3>Course - Assesment Passed</h3></Link>
                    <Link to="/ui/course-assesment-failed"><h3>Course - Assesment Failed</h3></Link>
                    <h2>Goals</h2>
                    <Link to="/ui/goals-in-progress"><h3>Goals In Progress</h3></Link>
                    <Link to="/ui/goals-met"><h3>Goals Met</h3></Link>
                    <Link to="/ui/comms-page"><h3>Comms Page</h3></Link>
                    <Link to="/ui/renault-incentive"><h3>Renault Incentive</h3></Link>


                    
                    
                    
                </UiCol>
            </UiRowContainer>
        </div>
    );
};

export default UiDemo;
